import React from 'react';
import PropTypes from 'prop-types';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { choseToCurrency } from '../../actions/getCurrencyRates';
import { closeHeaderModal } from '../../actions/modalActions';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import { showCurrencySymbol } from '../../helpers/currencyConvertion';

import s from './CurrencyModal.css';
function CurrencyModal() {
  const dispatch = useDispatch();

  const currencies = useSelector(state => state.currency.availableCurrencies);
  const baseCurrency = useSelector(state => state.currency.base);
  const toCurrency = useSelector(state => state.currency.to);
  const currentLocale = useSelector(state => state.intl.locale);

  const handleChange = (value) => {
    dispatch(choseToCurrency(value));
    dispatch(closeHeaderModal('languageModal'));
  };

  const targetCurrency = toCurrency || baseCurrency;
  const currencyList = currencies?.filter(o => o.symbol !== targetCurrency && o.isEnable == 1) || [];

  return (
    <div className={s.currencyAndLangGrid}>
      <div className={cx(s.activeItem, s.activeSection)} onClick={() => dispatch(closeHeaderModal('languageModal'))}>
        {showCurrencySymbol(targetCurrency, currentLocale) + targetCurrency}
      </div>

      {currencyList.length > 0 &&
        currencyList.map((item, index) => (
          <div className={cx(s.activeItem)} key={index} onClick={() => handleChange(item.symbol)}>
            {showCurrencySymbol(item.symbol, currentLocale) + item.symbol}
          </div>
        ))}
    </div>
  );
}

CurrencyModal.propTypes = {
  currencies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    symbol: PropTypes.string.isRequired,
    isEnable: PropTypes.bool.isRequired,
    isBaseCurrency: PropTypes.bool
  })),
  baseCurrency: PropTypes.string,
  toCurrency: PropTypes.string,
  currentLocale: PropTypes.string
};

export default withStyles(s)(CurrencyModal);
